import { Directive, Input, TemplateRef } from '@angular/core';

import type { SelectedItemContext } from './types';
import type { DefaultSelectContext, DefaultSelectSignalContext } from '../../types';

@Directive({
  standalone: true,
  selector: '[rtSelectSelectedItem]',
  exportAs: 'selectedItemDir',
})
export class Select2SelectedItemDirective<
  Select extends DefaultSelectContext | DefaultSelectSignalContext | null,
> {
  public static ngTemplateContextGuard<
    Select extends DefaultSelectContext | DefaultSelectSignalContext | null,
  >(dir: Select2SelectedItemDirective<Select>, ctx: unknown): ctx is SelectedItemContext<Select> {
    return true;
  }
  @Input() public rtSelectSelectedItem: Select;

  constructor(public templateRef: TemplateRef<SelectedItemContext<Select>>) {}
}
